import { useScrollReveal } from '../../hooks/useScrollReveal';

const METRICS = [
  {
    stat: '70%+',
    label: 'Reduction in Energy Costs',
    detail: 'Average savings across all LED upgrades',
    icon: 'ri-flashlight-fill',
  },
  {
    stat: '10+',
    label: 'Commercial Application Types',
    detail: 'Dealerships, retail, sports, industrial & more',
    icon: 'ri-building-4-line',
  },
  {
    stat: 'Signed',
    label: 'Sealed Photometric Plans',
    detail: 'Engineer-signed lighting plans for permits',
    icon: 'ri-file-certificate-line',
  },
  {
    stat: 'Solar',
    label: 'All-In-One Available',
    detail: 'Wire-free fixtures, no electrical installation',
    icon: 'ri-sun-fill',
  },
  {
    stat: 'FL+',
    label: 'Tampa Bay Based',
    detail: 'Serving Florida & nationwide',
    icon: 'ri-map-pin-2-fill',
  },
];

export default function TrustBar() {
  const { ref, visible } = useScrollReveal<HTMLDivElement>();

  return (
    <section className="bg-charcoal-mid border-b border-white/5">
      <div
        ref={ref}
        className={`mx-auto px-6 lg:px-12 xl:px-20 transition-all duration-700 ease-out ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
      >
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 divide-x divide-white/5">
          {METRICS.map((item, i) => (
            <TrustItem key={item.label} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function TrustItem({
  item,
  index,
}: {
  item: (typeof METRICS)[0];
  index: number;
}) {
  return (
    <div
      className={`group flex flex-col gap-2 px-6 py-6 lg:px-8 lg:py-7 hover:bg-white/[0.03] transition-colors duration-300 ${
        index === 4 ? 'hidden lg:flex' : ''
      }`}
    >
      {/* Icon + stat row */}
      <div className="flex items-baseline gap-3">
        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
          <i className={`${item.icon} text-gold text-base`}></i>
        </div>
        <span
          className="font-serif text-white font-light leading-none"
          style={{ fontSize: 'clamp(1.4rem, 2.5vw, 2rem)' }}
        >
          {item.stat}
        </span>
      </div>
      {/* Label */}
      <p className="text-white/70 text-[11px] font-semibold tracking-wider leading-snug">
        {item.label}
      </p>
      {/* Detail */}
      <p className="text-white/30 text-[10px] leading-snug hidden sm:block">
        {item.detail}
      </p>
    </div>
  );
}
